export default __webpack_public_path__ + "content/media/11.8b6757ce.jpg";